import { ReactNode, FC } from "react";
import classNames from "classnames";

import styles from "./styles.module.css";

/** The `Item` component properties. */
interface ItemContentProps {

  /** The item children. */
  readonly children?: ReactNode;
}

/** An individual draggable item within the orderable list. */
export const ItemContent: FC<ItemContentProps> = (props) => {
  const { children } = props;

  return (
    <div className={classNames(styles.ItemContent, "item-content")}>
      {children}
    </div>
  );
};
